import { useUser } from "hooks/use-user";
import CCAAssignedTicketsList from "./callCenterAgentTickets/assigned-tickets-list";
import DispatcherAssignedTicketsList from "./dispatcherTickets/assigned-tickets-list";
import { isCallCenterAgent } from "./utils";

export default function AssignedTicketsList() {
  const user = useUser();
  const isCCA = isCallCenterAgent(user);
  if (isCCA) {
    return <CCAAssignedTicketsList />;
  }
  return <DispatcherAssignedTicketsList />;
}
